import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "../lib/api";
import { useAuth } from "./AuthContext";

const AppContext = createContext(null);

export function AppProvider({ children }) {
    const { user } = useAuth();
    const [entities, setEntities] = useState([]);
    const [currencies, setCurrencies] = useState([]);
    const [selectedEntity, setSelectedEntity] = useState("all");
    const [selectedSegment, setSelectedSegment] = useState("all");

    const refreshMasters = useCallback(async () => {
        try {
            const [eRes, cRes] = await Promise.all([api.get("/entities"), api.get("/currencies")]);
            setEntities(eRes.data || []);
            setCurrencies(cRes.data || []);
        } catch {
            // ignore — page guards handle auth errors
        }
    }, []);

    // Re-fetch masters whenever the authenticated user becomes available
    // (login, refresh, or initial /auth/me success). Without this, the
    // initial 401 at app boot leaves entities=[] until a hard reload.
    useEffect(() => {
        if (user && user !== false) {
            refreshMasters();
        }
    }, [user, refreshMasters]);

    return (
        <AppContext.Provider
            value={{
                entities,
                currencies,
                selectedEntity,
                setSelectedEntity,
                selectedSegment,
                setSelectedSegment,
                refreshMasters,
            }}
        >
            {children}
        </AppContext.Provider>
    );
}

export function useAppCtx() {
    return useContext(AppContext);
}
